import {
  ListFundingsRequest,
  ListFundingsResponse,
} from '@cbinsights/fundingservice/fundingservice';

import { request } from 'client/modules/common/utils/request';

export const getListFundingDrafts = (
  req: ListFundingsRequest
): Promise<ListFundingsResponse> =>
  request({
    url: '/service/fundingservice/ListFundings',
    body: { ...req },
  }).then((r) => r.body);
